import { render, staticRenderFns } from "./ClassManageResources.vue?vue&type=template&id=2988c6ff&scoped=true&"
import script from "./ClassManageResources.vue?vue&type=script&lang=js&"
export * from "./ClassManageResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2988c6ff",
  null
  
)

export default component.exports